<template>
  <svg
    :width="size * 1.54"
    :height="size"
    viewBox="0 0 37 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.23306 14.6199V15.9999H10.5251V14.6199H8.86906V8.04395H7.38106L5.18506 8.94395L5.59306 10.1559L7.15306 9.51995V14.6199H5.23306Z"
      :fill="color"
    />
    <path d="M13.323 15.9999V14.1759H11.559V15.9999H13.323Z" :fill="color" />
    <path
      d="M19.589 8.04395H14.033V9.54395H17.789C16.493 11.1519 15.437 13.4799 14.789 15.9999H16.829C17.381 13.4439 18.317 11.1279 19.589 9.37595V8.04395Z"
      :fill="color"
    />
    <path
      d="M20.2826 12.5079C20.5706 12.4599 21.4226 12.4239 21.9746 12.4239C23.4146 12.4239 24.1106 12.7359 24.1106 13.6599C24.1106 14.4519 23.6666 14.8599 22.8746 14.8599C22.0466 14.8599 21.6626 14.4759 21.7466 13.6839H20.0186C19.7546 15.3639 20.6066 16.1559 22.7306 16.1559C24.8906 16.1559 25.8746 15.1239 25.8746 13.5279C25.8746 11.7879 24.7706 11.1399 22.6586 11.1399C22.4066 11.1399 22.1306 11.1519 21.8786 11.1639L22.0106 9.54395H25.3226L25.4546 8.04395H20.5706L20.2826 12.5079Z"
      :fill="color"
    />
    <path
      d="M32.0051 9.90395H30.2651C30.0611 10.3239 29.9051 10.6719 29.7851 10.9719C29.5571 11.5119 29.4251 11.8839 29.3531 12.0879H29.3291C29.2331 11.7999 29.0891 11.4399 28.8131 10.8879L28.2371 9.80795L26.4371 9.91595L27.9851 12.8919L26.3051 15.9999H28.0571C28.2971 15.5319 28.4291 15.2199 28.6331 14.8119C28.8851 14.2479 29.0771 13.8039 29.1251 13.6239H29.1611C29.2331 13.8639 29.3531 14.1999 29.7371 14.9319L30.3731 16.1079L32.1731 15.9999L30.5051 12.7959L32.0051 9.90395Z"
      :fill="color"
    />
    <mask id="path-2-inside-1" fill="transparent">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
      :fill="color"
    />
    <path
      d="M12 2.6H25V0H12V2.6ZM2.6 12C2.6 6.80852 6.80852 2.6 12 2.6V0C5.37258 0 0 5.37258 0 12H2.6ZM12 21.4C6.80852 21.4 2.6 17.1915 2.6 12H0C0 18.6274 5.37258 24 12 24V21.4ZM25 21.4H12V24H25V21.4ZM34.4 12C34.4 17.1915 30.1915 21.4 25 21.4V24C31.6274 24 37 18.6274 37 12H34.4ZM25 2.6C30.1915 2.6 34.4 6.80852 34.4 12H37C37 5.37258 31.6274 0 25 0V2.6ZM1.3 12C1.3 6.09055 6.09055 1.3 12 1.3V-1.3C4.65461 -1.3 -1.3 4.65461 -1.3 12H1.3ZM12 22.7C6.09055 22.7 1.3 17.9094 1.3 12H-1.3C-1.3 19.3454 4.65461 25.3 12 25.3V22.7ZM25 22.7H12V25.3H25V22.7ZM35.7 12C35.7 17.9094 30.9094 22.7 25 22.7V25.3C32.3454 25.3 38.3 19.3454 38.3 12H35.7ZM25 1.3C30.9094 1.3 35.7 6.09055 35.7 12H38.3C38.3 4.65461 32.3454 -1.3 25 -1.3V1.3ZM12 1.3H25V-1.3H12V1.3Z"
      :fill="color"
      mask="url(#path-2-inside-1)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
